import request from '@/utils/request'

// 租户用户API

// 分页查询租户用户列表
export function listTenantUsers(params) {
  return request({
    url: '/api/admin/tenant-users',
    method: 'get',
    params
  })
}

// 获取租户用户详情
export function getTenantUser(tenantUserId, tenantId) {
  return request({
    url: `/api/admin/tenant-users/${tenantUserId}`,
    method: 'get',
    params: { tenantId }
  })
}

// 加入黑名单
export function addToBlacklist(tenantUserId, tenantId, data) {
  return request({
    url: `/api/admin/tenant-users/${tenantUserId}/blacklist`,
    method: 'post',
    params: { tenantId },
    data
  })
}

// 移除黑名单
export function removeFromBlacklist(tenantUserId, tenantId) {
  return request({
    url: `/api/admin/tenant-users/${tenantUserId}/blacklist`,
    method: 'delete',
    params: { tenantId }
  })
}

// 获取黑名单用户列表
export function getBlacklistUsers(tenantId) {
  return request({
    url: '/api/admin/tenant-users/blacklist',
    method: 'get',
    params: { tenantId }
  })
}

// 更新用户标签
export function updateUserTags(tenantUserId, tenantId, tags) {
  return request({
    url: `/api/admin/tenant-users/${tenantUserId}/tags`,
    method: 'put',
    params: { tenantId },
    data: tags
  })
}

// 获取会话记录用户列表（按最后沟通时间排序）
export function getChatRecordUsers(params) {
  return request({
    url: '/api/admin/tenant-users/chat-records',
    method: 'get',
    params
  })
}

// 获取用户聊天记录（分页）
export function getUserChatMessages(userId, params) {
  return request({
    url: `/api/admin/tenant-users/chat-records/${userId}/messages`,
    method: 'get',
    params
  })
}
